@if (loadedError) {
<app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
} @if (!loadedError && loaded && !data) {
<app-widgets-overlay type="no-match"></app-widgets-overlay>
} @if (loaded) {
<div class="widget-container d-flex flex-column">
    <div class="widget-container__object">
        @if (!noTitle) {
        <h1 class="widget-title align-self-center">
            {{ 'web.widget_highest_scoring_half' | translate }}
            ( {{ num }} {{ 'web.matches' | translate }} )
        </h1>
        }
        <div class="d-flex">
            @if (data?.home; as p) {
            <div class="widget-team mt-1 d-flex flex-column" data-cy="team">
                <div class="widget-team__name d-flex align-items-center">
                    <img
                        (error)="imageError($event)"
                        [attr.src]="p.image | responsive : 'participant' : 'medium'"
                        [alt]="p.name"
                        class="img-fluid app-cursor mr-1"
                    />
                    <div>{{ p.name }}</div>
                </div>
            </div>
            } @if (data?.away; as p) {
            <div class="widget-team mt-1 d-flex flex-column widget-team--second" data-cy="team">
                <div class="widget-team__name d-flex align-items-center justify-content-end">
                    <div>{{ p.name }}</div>
                    <img
                        (error)="imageError($event)"
                        [attr.src]="p.image | responsive : 'participant' : 'medium'"
                        [alt]="p.name"
                        class="img-fluid app-cursor ml-1"
                    />
                </div>
            </div>
            }
        </div>
        <!-- Periods-->
        @for (period of periods; track $index) {
        <div class="d-flex flex-column widget-form-participant-container">
            <div class="d-flex justify-content-between">
                <div class="widget-form-participant widget-form-participant--home" data-cy="streakHome">
                    {{ periodsPrct('home', period[0]) | number : '1.2-2' }}%
                </div>
                <div class="widget-form-participant-text align-self-end">
                    {{ 'web.widget_win_period_' + period[0] | translate }}
                </div>
                <div class="widget-form-participant widget-form-participant--away" data-cy="streakAway">
                    {{ periodsPrct('away', period[0]) | number : '1.2-2' }}%
                </div>
            </div>
            <div class="d-flex">
                <div
                    class="widget-form-participant-bar widget-form-participant-bar--home"
                    [style.width.%]="width('home', period[0])"
                >
                    {{ data?.home?.name }}
                </div>
                <div
                    class="widget-form-participant-bar widget-form-participant-bar--away"
                    [style.width.%]="width('away', period[0])"
                >
                    {{ data?.away?.name }}
                </div>
            </div>
        </div>
        }
        <div class="w-100 text-center widget-form-participant-text app-word-nowrap">
            {{ 'web.num_of_matches' | translate }} ({{ num }})
        </div>
        <div class="widget-logo d-flex justify-content-center mt-4">
            <img
                [src]="'/img/' + client.getName() + '.png'"
                [alt]="client.getName()"
                data-cy="logo"
                class="widget-logo-client"
            />
        </div>
    </div>
</div>
}
